import React, { useState, useEffect } from 'react';
import { AuthContext, useAuthProvider } from './hooks/useAuth';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { DashboardPage } from './pages/DashboardPage';
import { MeetingPage } from './pages/MeetingPage';
import { ProfilePage } from './pages/ProfilePage';
import { Loader2 } from 'lucide-react';

export const App: React.FC = () => {
  const auth = useAuthProvider();
  const [route, setRoute] = useState(window.location.hash || '#/');

  useEffect(() => {
    const handleHashChange = () => {
      setRoute(window.location.hash || '#/');
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  if (auth.loading) {
    return (
      <div className="min-h-screen bg-[#090b10] flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-blue-500" />
      </div>
    );
  }

  // Routing logic
  let content = <LoginPage />;

  if (route.startsWith('#/meeting/')) {
    const publicId = route.slice('#/meeting/'.length).split('?')[0];
    content = <MeetingPage publicId={publicId} />;
  } else if (route === '#/register') {
    content = <RegisterPage />;
  } else if (route === '#/login') {
    content = <LoginPage />;
  } else if (route === '#/profile') {
    content = auth.user ? <ProfilePage /> : <LoginPage />;
  } else if (route === '#/dashboard' || route === '#/') {
    content = auth.user ? <DashboardPage /> : <LoginPage />;
  }

  return <AuthContext.Provider value={auth}>{content}</AuthContext.Provider>;
};
